import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const ComparisonRoute = LazyLoad(
  lazy(() =>
    import('./comparison-page.component').then((module) => ({
      default: module.ComparisonPage,
    })),
  ),
);
